var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide-fade" } }, [
    _vm.showMsg
      ? _c(
          "div",
          { class: { active: _vm.details }, attrs: { id: "cookies-warning" } },
          [
            _c("div", { staticClass: "btns" }, [
              _c(
                "button",
                {
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.setMsgCookie(false)
                    }
                  }
                },
                [
                  _vm._t("btn-selected", function() {
                    return [_vm._v("ACCEPT SELECTED")]
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.acceptAll()
                    }
                  }
                },
                [
                  _vm._t("btn-all", function() {
                    return [_vm._v("ACCEPT ALL")]
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("transition", { attrs: { name: "height" } }, [
              (_vm.viewportWidth > 575 && _vm.viewportHeight > 630) ||
              !_vm.details
                ? _c(
                    "div",
                    [
                      _vm._t("info", function() {
                        return [
                          _c("h6", [_vm._v("THIS WEBSITE USES COOKIES")]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n            We use cookies for two reasons. First, we use cookies that are strictly necessary for the\n            operation\n            and security of the website and second, we use cookies to identify you and analyze our\n            traffic\n            provided that you have given your permission by checking the box “Statistics”.\n          "
                            )
                          ])
                        ]
                      })
                    ],
                    2
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm._t("checkboxes", function() {
              return [
                _c("div", { staticClass: "checkboxes" }, [
                  _c(
                    "div",
                    {
                      staticClass: "checkbox-wrapper disabled",
                      on: {
                        click: function($event) {
                          return _vm.alert(_vm.alertMsg)
                        }
                      }
                    },
                    [
                      _c("label", { attrs: { for: "necessary" } }, [
                        _c("span", { staticClass: "checkbox-text" }, [
                          _vm._v("NECESSARY")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cookies.necessary,
                              expression: "cookies.necessary"
                            }
                          ],
                          attrs: {
                            id: "necessary",
                            type: "checkbox",
                            disabled: ""
                          },
                          domProps: {
                            checked: Array.isArray(_vm.cookies.necessary)
                              ? _vm._i(_vm.cookies.necessary, null) > -1
                              : _vm.cookies.necessary
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.cookies.necessary,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.cookies,
                                      "necessary",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.cookies,
                                      "necessary",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.cookies, "necessary", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "checkbox" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "checkbox-wrapper" }, [
                    _c("label", { attrs: { for: "statistics" } }, [
                      _c("span", { staticClass: "checkbox-text" }, [
                        _vm._v("STATISTICS")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.cookies.statistics,
                            expression: "cookies.statistics"
                          }
                        ],
                        attrs: { id: "statistics", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.cookies.statistics)
                            ? _vm._i(_vm.cookies.statistics, null) > -1
                            : _vm.cookies.statistics
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.cookies.statistics,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.cookies,
                                    "statistics",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.cookies,
                                    "statistics",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.cookies, "statistics", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "checkbox" })
                    ])
                  ])
                ])
              ]
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-details",
                class: { active: _vm.details },
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.toggleDetails()
                  }
                }
              },
              [
                _vm._t("btn-details", function() {
                  return [_c("span", [_vm._v("MORE DETAILS")])]
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "details" }, [
              _c("div", { staticClass: "tabs" }, [
                _c("div", { staticClass: "tabs-btns" }, [
                  _c(
                    "button",
                    {
                      staticClass: "tab-btn",
                      class: { active: _vm.tab === 1 },
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.tab = 1
                        }
                      }
                    },
                    [
                      _vm._t("tab-1", function() {
                        return [_vm._v("COOKIE DECLARATION")]
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "tab-btn",
                      class: { active: _vm.tab === 2 },
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.tab = 2
                        }
                      }
                    },
                    [
                      _vm._t("tab-2", function() {
                        return [_vm._v("ABOUT COOKIES")]
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tab-content" }, [
                  _vm.tab === 1
                    ? _c("div", { staticClass: "tabs-hor" }, [
                        _c("div", { staticClass: "tabs-hor-btns" }, [
                          _c(
                            "button",
                            {
                              staticClass: "tab-btn-hor",
                              class: { active: _vm.tabHor === 1 },
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.tabHor = 1
                                }
                              }
                            },
                            [
                              _vm._t("tab-1", function() {
                                return [_vm._v("NECESSARY")]
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "tab-btn-hor",
                              class: { active: _vm.tabHor === 2 },
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.tabHor = 2
                                }
                              }
                            },
                            [
                              _vm._t("tab-2", function() {
                                return [_vm._v("STATISTICS")]
                              })
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "tab-content-hor" }, [
                          _vm.tabHor === 1
                            ? _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "bar",
                                      rawName: "v-bar",
                                      value: { preventParentScroll: true },
                                      expression: "{preventParentScroll: true}"
                                    }
                                  ],
                                  staticClass: "h-100"
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _vm._t("details-necessary", function() {
                                        return [
                                          _c("p", [
                                            _vm._v(
                                              "\n                      Necessary cookies are used to provide and protect our services while\n                      providing a swift and safer browsing experience by enabling basic\n                      functions\n                      like page navigation. The website cannot function properly without these\n                      cookies.\n                    "
                                            )
                                          ])
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.tabHor === 2
                            ? _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "bar",
                                      rawName: "v-bar",
                                      value: { preventParentScroll: true },
                                      expression: "{preventParentScroll: true}"
                                    }
                                  ],
                                  staticClass: "h-100"
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _vm._t("details-statistics", function() {
                                        return [
                                          _c("h6", [_vm._v("STATISTICS")])
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "h-100" }, [
                    _vm.tab == 2
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "bar",
                                rawName: "v-bar",
                                value: { preventParentScroll: true },
                                expression: "{preventParentScroll: true}"
                              }
                            ],
                            staticClass: "h-100"
                          },
                          [_c("div", [_vm._t("details-about")], 2)]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ])
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }